import * as React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { useParams, useLocation, useSearchParams } from 'react-router-dom';
import * as JSTool from '../store/JSTool';


export default function Survey(props) {
    const [searchParams, setSearchParams] = useSearchParams();
    const url = 'https://aplusjapan.aihelp.net/form/#/?unionId=dc7d73d897904e7484baf1d233e8b5b5&ep=6962780c8a259bf2f0f00c5c26db1b8d0952f1a744ad20f17438b746b9f35c37a45d2283285f33af';

    React.useEffect(() => {
        const uid = searchParams.get('userId');
        if (!JSTool.isEmpty(uid)) {
            window.location.href = url + '&userId=' + uid;
        } else {
            window.location.href = url;
        }

    }, []);

    return (
        <Stack>
        </Stack>
    )
}           
